import React from 'react';

import { useScrollToTopOnMount } from '../../hooks/useScrollToTopOnMount';

import IndividualCasting from './IndividualCasting/IndividualCasting';
import IdealMatch from './IdealMatch/IdealMatch';
import Parsing from './Parsing/Parsing';
import InResult from './InResult/InResult';
import UniversalExpert from './UniversalExpert/UniversalExpert';
import FreeConsultation from '../../components/FreeConsultation/FreeConsultation';
import { sectionIds } from '../../utils/constants';
import { PagesEnum } from '../../utils/enums';

import './freeConsultationPage.scss';

export const freeConsultationId = 'free-consultation-section';

function FreeConsultationPage() {
  useScrollToTopOnMount();

  return (
    <main className='page consultation-page'>
      <IndividualCasting id={sectionIds[PagesEnum.FreeConsultation].individualCasting} />
      <IdealMatch id={sectionIds[PagesEnum.FreeConsultation].idealMatch} />
      <Parsing id={sectionIds[PagesEnum.FreeConsultation].parsing} />
      <InResult id={sectionIds[PagesEnum.FreeConsultation].inResult} />
      <UniversalExpert id={sectionIds[PagesEnum.FreeConsultation].universalExpert} />
      <FreeConsultation
        id={sectionIds[PagesEnum.FreeConsultation].consultation}
        title='Не останавливайся'
        subTitle='ЗАПИШИСЬ НА РАЗБОР'
        description='Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом'
      />
    </main>
  );
}

export default FreeConsultationPage;
